module.exports = __webpack_public_path__ + "static/img/zhongliang.83dd6e4d.png";